import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { PrefsProvider } from "@/context/PrefsContext";
import AppLayout from "@/components/AppLayout";
import Login from "@/pages/Login";
import Clients from "@/pages/Clients";
import Carriers from "@/pages/Carriers";
import Users from "@/pages/Users";
import Companies from "@/pages/Companies";
import Config from "@/pages/Config";
import Loads from "@/pages/Loads";
import Cruces from "@/pages/Cruces";
import Unidades from "@/pages/Unidades";
import Cajas from "@/pages/Cajas";
import LoadForm from "@/pages/LoadForm";
import LoadDetail from "@/pages/LoadDetail";
import RateCards from "@/pages/RateCards";
import ReferenciasCummins from "@/pages/ReferenciasCummins";
import Dashboard from "@/pages/Dashboard";
import Documents from "@/pages/Documents";
import DocumentUploadLoad from "@/pages/DocumentUploadLoad";
import DocumentUploadInvoice from "@/pages/DocumentUploadInvoice";
import Alerts from "@/pages/Alerts";
import Auditoria from "@/pages/Auditoria";
import QuickBooksMatches from "@/pages/QuickBooksMatches";
import Reports from "@/pages/Reports";
import Guias from "@/pages/Guias";
import IntegracionDAT from "@/pages/IntegracionDAT";
import FacturacionQBO from "@/pages/FacturacionQBO";
// P35 (2026-09-23): términos y privacidad públicos — Intuit los exige para las claves de producción.
import { Terminos, Privacidad } from "@/pages/Legal";
// P36 (2026-09-25): resultado de la autorización de QuickBooks — la ve el administrador de QBO, sin sesión.
import ConexionQuickBooks from "@/pages/ConexionQuickBooks";

function Protected({ children }) {
  const { user, checking } = useAuth();
  if (checking || user === null)
    return (
      <div className="flex h-screen items-center justify-center text-sm text-muted-foreground">
        Cargando...
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function Shell() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route
        path="/login"
        element={user ? <Navigate to="/" replace /> : <Login />}
      />
      {/* P35 (2026-09-23): públicas a propósito. Intuit (y cualquiera) las tiene que poder abrir SIN
          iniciar sesión: son las URLs de EULA y de política de privacidad de la app de QuickBooks.
          No las muevas adentro de <Protected> ni les pongas redirección a /login. */}
      <Route path="/terminos" element={<Terminos />} />
      <Route path="/privacidad" element={<Privacidad />} />
      {/* P36 (2026-09-25): acá manda el backend al terminar el callback de Intuit. Quien autoriza es el
          administrador de QuickBooks y no tiene usuario en la plataforma: tiene que ver el resultado
          SIN sesión. No la muevas adentro de <Protected>. */}
      <Route path="/conexion-quickbooks" element={<ConexionQuickBooks />} />
      <Route
        path="/"
        element={
          <Protected>
            <AppLayout />
          </Protected>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="loads" element={<Loads />} />
        <Route path="loads/nuevo" element={<LoadForm />} />
        <Route path="loads/:id" element={<LoadDetail />} />
        <Route path="cruces" element={<Cruces />} />
        <Route path="unidades" element={<Unidades />} />
        <Route path="cajas" element={<Cajas />} />
        <Route path="clients" element={<Clients />} />
        <Route path="carriers" element={<Carriers />} />
        <Route path="rate-cards" element={<RateCards />} />
        <Route path="referencias-cummins" element={<ReferenciasCummins />} />
        <Route path="documents" element={<Documents />} />
        <Route path="documents/nuevo-load" element={<DocumentUploadLoad />} />
        <Route path="documents/nueva-factura" element={<DocumentUploadInvoice />} />
        <Route path="alerts" element={<Alerts />} />
        <Route path="audit" element={<Auditoria />} />
        <Route path="quickbooks" element={<QuickBooksMatches />} />
        <Route path="reports" element={<Reports />} />
        <Route path="guias" element={<Guias />} />
        <Route path="facturacion-qbo" element={<FacturacionQBO />} />
        <Route path="users" element={<Users />} />
        <Route path="companies" element={<Companies />} />
        <Route path="config" element={<Config />} />
        <Route path="integracion-dat" element={<IntegracionDAT />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <PrefsProvider>
        <BrowserRouter>
          <Shell />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </PrefsProvider>
    </AuthProvider>
  );
}
